<template>
    <div class="video" style="cursor: pointer;">
        <!-- 拌合楼小视频 -->
        <!-- v-show="mixingPlantMin && mOpen" -->
        <div class="mixingPlantBox">
            <div v-for="(camera, index) in mixingPlantCameras.slice(0, 3)" :key="camera.site" class="mixingPlant"
                @click="enlargeMixingPlantCamera(index)">
                <!-- 小屏不渲染播放器，仅显示监控封面 + 播放按钮 -->
                <div class="camera-placeholder">
                    <img v-if="camera.posterUrl" :src="camera.posterUrl" alt="监控画面" />
                    <div class="play-hint">
                        <i class="el-icon-video-play play-hint-icon"></i>
                    </div>
                </div>
            </div>
        </div>
        <!-- 视屏放大 -->
        <div class="enlargeVideo" v-show="!mixingPlantMin || !fronCourtMin">
            <!-- 关闭按钮 -->
            <div class="close" @click="close">X</div>
            <!-- 放大视频 -->
            <div class="videos" v-show="!cloudImgFlag">
                <div class="cloudImgMax1" ref="cloudImgMax" v-if="isCanMove">
                    <div class="btnL"><i @click="moveCameraGo(2)" class="el-icon-caret-left"></i></div>
                    <div class="btnR"><i @click="moveCameraGo(3)" class="el-icon-caret-right"></i></div>
                    <div class="btnT"><i @click="moveCameraGo(0)" class="el-icon-caret-top"></i></div>
                    <div class="btnB"><i @click="moveCameraGo(1)" class="el-icon-caret-bottom"></i></div>
                </div>

                <!-- 播放舞台：播放器容器保持空节点，封面/加载层放外面，避免被 EZUIKit 清掉 -->
                <div class="video-stage">
                    <div v-if="t" :id="videoContainerId" class="ez-video-container"></div>

                    <!-- 暂停/起播过渡封面 -->
                    <img
                        v-show="pauseImageUrl && (!isEnlargePlaying || playLoading)"
                        :src="pauseImageUrl"
                        class="pause-image"
                        alt="暂停画面"
                    />

                    <!-- 暂停 → 正式播放过渡加载 -->
                    <div v-if="playLoading" class="play-loading">
                        <i class="el-icon-loading play-loading-icon"></i>
                        <span class="play-loading-text">加载中</span>
                    </div>

                    <!-- 暂停时的播放按钮 -->
                    <div
                        v-show="t && !isEnlargePlaying && !playLoading"
                        class="play-button-overlay"
                        @click="resumeEnlargePlay"
                    >
                        <i class="el-icon-video-play play-icon"></i>
                        <span class="play-text">点击继续播放</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="cloudImgMBox" v-show="cloudImgFlag">
            <div class="cloudImgM" ref="cloudImgM">
                <div @click="closeCloud" class="closeCloud"><i class="el-icon-close"></i></div>
                <iframe ref="IframeM" id="bdIframeM" :src="bdTokenUrl2" frameborder="0" scrolling="no"></iframe>
            </div>
        </div>
    </div>
</template>
<script>
import { getChannels, getImgUrl, getNewChannels, getNewImgUrl, touchchannelstream, getRealChannel, getAppKey, moveCameraR, getVideoConfigGetList, disableLiveAddress, captureImage } from "@/api/api";
import { mapState } from "vuex";
import EZUIKit from 'ezuikit-js';
import { buildHideGlobalFullscreenTheme } from '@/utils/ezuikitTheme'
export default {
    props: {},
    components: {},
    data() {
        return {
            bdTokenUrl: "",//三个不同大小云图的地址
            bdTokenUrl1: "",
            bdTokenUrl2: "",
            mixingPlantMin: true,//拌合楼视频是否放大
            fronCourtMin: true,//前场视频是否放大
            cloudImgFlag: false,//云图是否放大
            baseUrl: "http://119.45.190.236:10800",
            t1: '',
            img1: '',
            t2: '',
            img2: '',
            t: '',
            img: '',
            windowWidth: '',
            mOpen: false,
            fOpen: false,
            materialType: 'lq',
            channelM: '',
            channelF: '',
            intervalId: null,
            tokenStr: '',
            direction: '',
            deviceSerial: '',
            channelNo: '',
            isCanMove: false,
            // 左侧拌合楼摄像头列表
            mixingPlantCameras: [],
            // 右侧摊铺机摄像头对象
            paverCamera: null,
            currentCameraIndex: -1, // 当前放大的摄像头索引
            // 播放控制相关
            enlargePlayStartTime: null,    // 放大弹框开始播放的时间戳
            enlargePlayTimer: null,        // 自动暂停定时器引用
            // 最大播放时长（分钟），后续改这里即可
            MAX_PLAY_MINUTES: 10,
            isEnlargePlaying: false,       // 放大弹框是否正在播放
            playLoading: false,            // 暂停封面 → 正式播放过渡加载
            ezPlayerInstance: null,        // EZUIKit 播放器实例
            videoContainerId: 'ez-video-container',  // 容器ID
            pauseImageUrl: '',             // 暂停截图URL
            // 缓存所有设备列表(用于切换拌合楼时过滤)
            allMixingPlantDevices: [],     // 所有拌合楼设备(codeType=1)
            allPaverDevices: []            // 所有摊铺机设备(codeType=2)
        };
    },
    created() { },
    mounted() {
        let that = this;
        this.dataRefreh()
        this.getAppKeys()
        console.log('route', this.$route.path)
        if (this.$route.path.indexOf("lq") >= 0) {
            this.materialType = "lq"
        } else {
            this.materialType = "sw"
        }
    },
    methods: {
        // 获取当天日期（用于云图 time 参数）
        getTodayDate() {
            const d = new Date()
            const y = d.getFullYear()
            const m = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')
            return `${y}-${m}-${day}`
        },
        // 获取萤石appKey
        async getAppKeys() {
            const ertData = await getAppKey();
            console.log(ertData)
            this.tokenStr = ertData.data
        },
        // 移动镜头
        async moveCameraGo(val) {
            let req = {
                accessToken: this.tokenStr,
                deviceSerial: this.deviceSerial,
                channelNo: this.channelNo,
                direction: val,
                speed: 1,
                type: 1
            };
            const ertData = await moveCameraR(req);
            console.log(ertData)
            if (ertData.status == 200) {
                setTimeout(() => {
                    this.moveCameraStop(val)
                }, 500);
            }
        },
        // 停止镜头
        async moveCameraStop() {
            let req = {
                accessToken: this.tokenStr,
                deviceSerial: this.deviceSerial,
                channelNo: this.channelNo,
                direction: this.direction,
                speed: 1,
                type: 2
            };
            const ertData = await moveCameraR(req);
            console.log(ertData)
        },
        getHcCameraLabel(key) {
            const labelMap = {
                slkVideo: '上料口',
                lqjzkVideo: '沥青加注口',
                clkVideo: '出料口',
                yclkVideo: '原材料口'
            }
            return labelMap[key] || ''
        },
        getSiteByCameraKey(key) {
            const keyToSiteMap = {
                slkVideo: 1,    // 上料口
                lqjzkVideo: 2,  // 沥青加注口
                clkVideo: 3,    // 出料口
                yclkVideo: 4    // 原材料口
            };
            return keyToSiteMap[key];
        },
        findHcChannel(list, key) {
            if (!list || !list.length) return null
            const label = this.getHcCameraLabel(key)
            if (!label) return list[0]
            const matched = list.find((item) => {
                const text = [item.name, item.place, item.channelName, item.position, item.remark]
                    .filter(Boolean)
                    .join('')
                return text.indexOf(label) >= 0
            })
            return matched || list[0]
        },
        applyChannel(channel) {
            if (!channel) return
            this.t = channel.url
            this.deviceSerial = channel.serialNumber
            this.channelNo = channel.channel
            this.isCanMove = channel.isPtz == 1
        },
        // 后场指定点位放大
        async openHcCameraEnlarge(key) {
            const targetSite = this.getSiteByCameraKey(key);
            if (!targetSite) {
                console.warn('未知的摄像头key:', key);
                return;
            }

            // 在 mixingPlantCameras 中查找对应的摄像头
            const cameraIndex = this.mixingPlantCameras.findIndex(cam => cam.site === targetSite);
            if (cameraIndex === -1) {
                this.$message({ message: '未配置监控设备', type: 'warning' });
                return;
            }

            const camera = this.mixingPlantCameras[cameraIndex];

            // 直接调用放大方法，不管是否有视频URL
            this.enlargeMixingPlantCamera(cameraIndex);
        },
        // 获取监控视频列表
        async getRealChannels(val) {
            console.log('getRealChannels', val)
            let req = {
                engineeringId: this.engineerId,
                workareaId: this.sectionId,
                site: val  //1前2后
            };
            const ertData = await getRealChannel(req);
            console.log(ertData)
            const list = ertData.data || []
            if (!list.length) return
            if (val == 1) {
                this.t2 = list[0].url
                // this.t1 = list[0].url
            } else if (val == 2) {
                this.t1 = list[0].url
            }
            this.applyChannel(list[0])
        },
        generateTimestampId() {
            const timestamp = Date.now().toString();
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let rand = '';

            if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
                // 浏览器安全随机
                const arr = new Uint32Array(16);
                crypto.getRandomValues(arr);
                for (const n of arr) rand += chars[n % chars.length];
            } else {
                try {
                    // Node.js 安全随机
                    const { randomBytes } = require('crypto');
                    const buf = randomBytes(16);
                    for (const n of buf) rand += chars[n % chars.length];
                } catch (e) {
                    // 兜底
                    for (let i = 0; i < 16; i++) rand += chars[Math.floor(Math.random() * chars.length)];
                }
            }

            return timestamp + rand;
        },
        bigThanBig() {
            let that = this;
            this.cloudImgFlag = true
            that.$nextTick(function () {
                let oIframeM = document.getElementById("bdIframeM");
                let deviceWidthM = that.$refs.cloudImgM ? that.$refs.cloudImgM.offsetWidth : 0;
                let deviceHeightM = that.$refs.cloudImgM ? that.$refs.cloudImgM.offsetHeight : 0;
                if (oIframeM && deviceWidthM > 0) {
                    oIframeM.style.width = Number(deviceWidthM) - 2 + "px";
                    oIframeM.style.height = Number(deviceHeightM) - 2 + "px";
                }
                // this.workAreaId = 348
                // this.engineerId = 266
                // this.sectionId = 256
                // this.isHistory = 'realTime1'
                // this.materialType = 'lq'
                let time = this.getTodayDate()
                console.log(this.materialType)
                // &source=3
                that.bdTokenUrl2 =
                    // `https://henan-zk-cloudvue-sit.jsti-smart.cn/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.seIds}&isHistory=realTime&materialType=${this.materialType}&time=${time}&machineType=13&authkey=${this.generateTimestampId()}`;
                    // `http://cloudvue.jsti-smart.cn/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.seIds}&isHistory=realTime&materialType=${this.materialType}&time=${time}&machineType=13&authkey=${this.generateTimestampId()}`;
                    `https://cloudvue-henan.jsti-smart.cn/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.seIds}&isHistory=realTime&materialType=${this.materialType}&time=${time}&machineType=13&authkey=${this.generateTimestampId()}`;
                //  that.bdTokenUrl2 =
                //   `http://59.110.143.238:1088/?workArea=348&engineerId=266&sectionId=${this.sectionId}&isHistory=realTime&materialType=sw&time=${time}&machineType=13`;
                console.log(that.bdTokenUrl2)
            });
        },
        closeCloud() {
            this.cloudImgFlag = false
        },
        //获取视频流URL
        async getVideoStreamUrl(accessToken, serialNumber, channelNo, quality = 1) {
            try {
                let params = {
                    accessToken: accessToken,
                    deviceSerial: serialNumber,
                    channelNo: channelNo,
                    quality: quality,
                    protocol: 2
                }
                const res = await getNewImgUrl(params);
                // 返回完整数据对象,包含 url 和 id
                if (res && res.data && res.data.code === '200') {
                    return {
                        url: res.data.data.url,
                        urlId: res.data.data.id  // 保存urlId用于后续销毁
                    };
                }
                console.warn('获取视频流失败:', res && res.data && res.data.msg);
                return { url: '', urlId: '' };
            } catch (error) {
                console.error('获取视频流失败:', error);
                return { url: '', urlId: '' };
            }
        },
        // 销毁监控流
        async disableVideoStream(accessToken, deviceSerial, urlId) {
            if (!accessToken || !deviceSerial || !urlId) {
                console.warn('销毁视频流参数不完整');
                return;
            }

            try {
                let params = {
                    accessToken: accessToken,
                    deviceSerial: deviceSerial,
                    urlId: urlId
                };
                const res = await disableLiveAddress(params);
                console.log('销毁视频流成功:', res);
            } catch (error) {
                console.error('销毁视频流失败:', error);
            }
        },
        //获取视频图片和地址
        async getVideo(mixplantNo) {
            // 初始化数据结构
            this.mixingPlantCameras = [];
            this.paverCamera = null;

            let that = this

            // 左侧拌合楼设备获取 - 不在请求参数中传code,从返回结果中过滤
            let req = {
                engineeringId: this.engineerId,
                sectionId: this.workAreaId,
                workareaId: this.sectionId,
                codeType: 1  // 拌合楼,不传code参数
            }
            // 获取小视频显示大小
            this.$nextTick(function () {
                let width = this.$refs.fronCourt ? this.$refs.fronCourt.offsetWidth : 0;
                let height = this.$refs.fronCourt ? this.$refs.fronCourt.offsetHeight : 0;
                this.windowWidth = width + ":" + height
            })

            // 使用新接口 /e/r/ys/video/config/getList
            const { data } = await getVideoConfigGetList(req);
            console.log('拌合楼设备列表参数', req)
            console.log('拌合楼设备列表', data)

            // 处理返回数据，支持多种格式
            let deviceList = []
            if (Array.isArray(data)) {
                deviceList = data
            } else if (data && Array.isArray(data.result)) {
                deviceList = data.result
            } else if (data && Array.isArray(data.records)) {
                deviceList = data.records
            } else if (data && Array.isArray(data.data)) {
                deviceList = data.data
            }

            console.log('解析后的拌合楼设备列表:', deviceList)

            // 缓存所有拌合楼设备(只在首次调用时缓存)
            if (this.allMixingPlantDevices.length === 0) {
                this.allMixingPlantDevices = deviceList;
                console.log('已缓存所有拌合楼设备:', this.allMixingPlantDevices.length);
            }

            console.log(mixplantNo, 1111111)
            // 根据code字段匹配并取前3个设备(从缓存的设备列表中过滤)
            if (mixplantNo) {
                // 筛选出code等于mixplantNo的设备
                const matchedDevices = deviceList.filter(device => device.code === mixplantNo);
                console.log(`匹配到拌合楼 ${mixplantNo} 的设备数量:`, matchedDevices.length);
                // 只取前3个
                matchedDevices.slice(0, 3).forEach((device, index) => {
                    const cameraNames = ['上料口', '沥青加注口', '出料口'];
                    this.mixingPlantCameras.push({
                        ...device,
                        channelNo: device.channel || '1',
                        serialNumber: device.serialNumber,
                        accessToken: device.accessToken,
                        urlId: '',  // 用于存储视频流ID
                        posterUrl: '',
                        quality: 2,
                        isPtz: device.isPtz || 0  // 是否支持云台控制
                    });
                });
            }

            console.log('拌合楼摄像头列表:', this.mixingPlantCameras);

            // 右侧摊铺机设备获取 - 单独调用接口
            let paverReq = {
                engineeringId: this.engineerId,
                sectionId: this.workAreaId,
                workareaId: this.sectionId,
                codeType: 2  // 摊铺机
            }

            const { data: paverData } = await getVideoConfigGetList(paverReq);
            console.log('摊铺机设备列表参数', paverReq)
            console.log('摊铺机设备列表', paverData)

            // 解析摊铺机设备列表
            let paverDeviceList = []
            if (Array.isArray(paverData)) {
                paverDeviceList = paverData
            } else if (paverData && Array.isArray(paverData.result)) {
                paverDeviceList = paverData.result
            } else if (paverData && Array.isArray(paverData.records)) {
                paverDeviceList = paverData.records
            } else if (paverData && Array.isArray(paverData.data)) {
                paverDeviceList = paverData.data
            }

            console.log('解析后的摊铺机设备列表:', paverDeviceList)

            // 缓存所有摊铺机设备(只在首次调用时缓存)
            if (this.allPaverDevices.length === 0) {
                this.allPaverDevices = paverDeviceList;
                console.log('已缓存所有摊铺机设备:', this.allPaverDevices.length);
            }

            // 按site字段筛选(假设site=10为摊铺机),只保留1条
            this.paverCamera = null;
            const paverDevice = paverDeviceList.find(device => device.site === 10);
            if (paverDevice) {
                this.paverCamera = {
                    site: 10,
                    name: '摊铺机',
                    channelNo: paverDevice.channel || '1',
                    serialNumber: paverDevice.serialNumber,
                    accessToken: paverDevice.accessToken,
                    videoUrl: '',
                    urlId: '',  // 用于存储视频流ID
                    posterUrl: '',
                    quality: 2,
                    isPtz: paverDevice.isPtz || 0  // 是否支持云台控制
                };
                console.log('摊铺机匹配成功', {
                    deviceName: paverDevice.deviceName,
                    channelNo: paverDevice.channel,
                    serialNumber: paverDevice.serialNumber
                });
            }

            console.log('摊铺机摄像头:', this.paverCamera);

            // 小屏封面抓拍（未播放时显示监控画面）
            this.loadCameraPosters()

            // 兼容旧逻辑：设置 mOpen 和 fOpen
            if (this.mOpen) {
                // 后场第一个有视频的设备
                const backCamera = this.mixingPlantCameras.find(cam => cam.videoUrl);
                if (backCamera) {
                    this.t1 = backCamera.videoUrl;
                    this.img1 = backCamera.posterUrl;
                }
            }

            if (this.fOpen) {
                // 前场设备（摊铺机）
                if (this.paverCamera && this.paverCamera.videoUrl) {
                    this.t2 = this.paverCamera.videoUrl;
                    this.img2 = this.paverCamera.posterUrl;
                    //获取小视频显示大小
                    const oIframe = document.getElementById("bdIframe");
                    console.log('材料类型', this.materialType)
                    that.$nextTick(function () {
                        let deviceWidth = that.$refs.fronCourt ? that.$refs.fronCourt.offsetWidth : 0;
                        let deviceHeight = that.$refs.fronCourt ? that.$refs.fronCourt.offsetHeight : 0;
                        if (oIframe && deviceWidth > 0) {
                            oIframe.style.width = Number(deviceWidth) - 2 + "px";
                            oIframe.style.height = Number(deviceHeight) - 2 + "px";
                        }
                        that.bdTokenUrl =
                            `http://59.110.143.238:1088/?workArea=${this.sectionId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=1`;
                    });
                }
            }
        },
        // 从缓存中过滤拌合楼设备(不调用接口)
        filterMixingPlantCameras(mixplantNo) {
            console.log('从缓存中过滤拌合楼设备, mixplantNo:', mixplantNo);

            if (!mixplantNo || this.allMixingPlantDevices.length === 0) {
                console.warn('没有缓存的拌合楼设备或mixplantNo为空');
                return;
            }

            // 从缓存的设备列表中筛选
            const matchedDevices = this.allMixingPlantDevices.filter(device => device.code === mixplantNo);
            console.log(`匹配到拌合楼 ${mixplantNo} 的设备数量:`, matchedDevices.length);

            // 清空当前列表
            this.mixingPlantCameras = [];

            // 只取前3个
            matchedDevices.slice(0, 3).forEach((device, index) => {
                this.mixingPlantCameras.push({
                    ...device,
                    channelNo: device.channel || '1',
                    serialNumber: device.serialNumber,
                    accessToken: device.accessToken,
                    urlId: '',  // 用于存储视频流ID
                    posterUrl: '',
                    quality: 2,
                    isPtz: device.isPtz || 0  // 是否支持云台控制
                });
            });

            console.log('过滤后的拌合楼摄像头列表:', this.mixingPlantCameras);
            this.loadCameraPosters()
        },
        // 小屏封面：调用萤石抓拍，未播放时展示监控画面
        async loadCameraPosters () {
            const list = [...this.mixingPlantCameras]
            if (this.paverCamera) list.push(this.paverCamera)
            for (const camera of list) {
                await this.fetchCameraPoster(camera)
            }
        },
        async fetchCameraPoster (camera) {
            if (!camera || !camera.serialNumber) return
            const accessToken = camera.accessToken || this.tokenStr
            if (!accessToken) return
            try {
                const res = await captureImage({
                    accessToken,
                    deviceSerial: camera.serialNumber,
                    channelNo: camera.channelNo || '1'
                })
                const picUrl = res && res.data && res.data.data ? res.data.data.picUrl : ''
                if (picUrl) {
                    this.$set(camera, 'posterUrl', picUrl)
                }
            } catch (error) {
                console.warn('小屏封面抓拍失败:', camera.name || camera.serialNumber, error)
            }
        },
        clearPlayLoadingTimer () {
            if (this._playLoadingTimer) {
                clearTimeout(this._playLoadingTimer)
                this._playLoadingTimer = null
            }
        },
        finishPlayLoading () {
            this.clearPlayLoadingTimer()
            this.playLoading = false
            // 出画面后再去掉封面，避免黑屏
            if (this.isEnlargePlaying) {
                this.pauseImageUrl = ''
            }
        },
        beginPlayLoading (posterUrl) {
            this.playLoading = true
            this.isEnlargePlaying = false
            if (posterUrl) this.pauseImageUrl = posterUrl
            this.clearPlayLoadingTimer()
            this._playLoadingTimer = setTimeout(() => {
                this.finishPlayLoading()
            }, 15000)
        },
        //保活接口
        isOnline() {
            // 只对当前正在播放的视频进行保活
            let activeCamera = null;

            if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                activeCamera = this.mixingPlantCameras[this.currentCameraIndex];
            } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                activeCamera = this.paverCamera;
            }

            // // 如果有正在播放的摄像头且有视频URL,则进行保活
            // if (activeCamera && activeCamera.channelNo && activeCamera.videoUrl) {
            //     touchchannelstream({
            //         channel: activeCamera.channelNo,
            //         protocol: 'FlV'
            //     });
            // }
        },
        dataRefreh() {
            let that = this
            // 计时器正在进行中，退出函数
            if (this.intervalId != null) {
                return;
            }
            // 计时器为空，操作
            this.intervalId = setInterval(() => {
                this.isOnline()
            }, 30000);
        },
        //放大拌合楼视频
        enlargeMixingP() {
            this.mixingPlantMin = false;
            this.t = this.t1
            this.img = this.img1
        },
        //放大前场视频
        enlargeFronC() {
            let that = this;
            that.fronCourtMin = false;
            this.t = this.t2
            this.img = this.img2
            //获取大视频里小云图大小
            let oIframeM = document.getElementById("bdIframeMax");
            that.$nextTick(function () {
                let deviceWidthM = that.$refs.cloudImgMax ? that.$refs.cloudImgMax.offsetWidth : 0;
                let deviceHeightM = that.$refs.cloudImgMax ? that.$refs.cloudImgMax.offsetHeight : 0;
                if (oIframeM && deviceWidthM > 0) {
                    oIframeM.style.width = Number(deviceWidthM) - 2 + "px";
                    oIframeM.style.height = Number(deviceHeightM) - 2 + "px";
                }
                that.bdTokenUrl1 =
                    `http://59.110.143.238:1088/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=2`;
            });
        },
        //统一放大摄像头方法
        enlargeCamera(index) {
            if (index < 0 || index >= this.cameraList.length) return;
            const camera = this.cameraList[index];
            this.currentCameraIndex = index;
            this.t = camera.videoUrl;
            this.img = camera.posterUrl;
            this.mixingPlantMin = false;
            this.fronCourtMin = false;

            // 如果是摊铺机(index=5),显示云图控制
            if (index === 5) {
                this.deviceSerial = camera.serialNumber;
                this.channelNo = camera.channelNo;
                // 设置云图iframe地址
                let that = this;
                let oIframeM = document.getElementById("bdIframeMax");
                that.$nextTick(function () {
                    let deviceWidthM = that.$refs.cloudImgMax ? that.$refs.cloudImgMax.offsetWidth : 0;
                    let deviceHeightM = that.$refs.cloudImgMax ? that.$refs.cloudImgMax.offsetHeight : 0;
                    if (oIframeM && deviceWidthM > 0) {
                        oIframeM.style.width = Number(deviceWidthM) - 2 + "px";
                        oIframeM.style.height = Number(deviceHeightM) - 2 + "px";
                    }
                    that.bdTokenUrl1 =
                        `http://59.110.143.238:1088/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=2`;
                });
            }
        },
        // 放大左侧拌合楼摄像头
        async enlargeMixingPlantCamera(index) {
            if (index < 0 || index >= this.mixingPlantCameras.length) return;
            const camera = this.mixingPlantCameras[index];

            // 如果之前有视频流,先销毁旧的流
            if (camera.videoUrl && camera.urlId) {
                await this.disableVideoStream(
                    camera.accessToken,
                    camera.serialNumber,
                    camera.urlId
                );
            }

            // 每次都重新获取新的视频流URL和urlId
            if (camera.channelNo && camera.serialNumber && camera.accessToken) {
                const streamData = await this.getVideoStreamUrl(
                    camera.accessToken,
                    camera.serialNumber,
                    camera.channelNo,
                    camera.quality
                );
                this.$set(this.mixingPlantCameras[index], 'videoUrl', streamData.url);
                this.$set(this.mixingPlantCameras[index], 'urlId', streamData.urlId);
                console.log(`拌合楼 ${camera.name} 视频URL获取成功`);
            }

            this.currentCameraIndex = index;
            this.t = camera.videoUrl;
            this.img = camera.posterUrl;
            this.mixingPlantMin = false;
            this.fronCourtMin = false;

            // 设置设备信息用于 EZUIKit
            this.deviceSerial = camera.serialNumber;
            this.channelNo = camera.channelNo;
            this.isCanMove = camera.isPtz == 1;  // 根据设备实际能力设置

            // 先展示封面 + loading，再起播
            this.beginPlayLoading(camera.posterUrl)
            this.startEnlargePlay();
            this.initEZPlayer();
        },
        // 放大右侧摊铺机摄像头
        async enlargePaverCamera() {
            if (!this.paverCamera) return;
            console.log('放大右侧摊铺机摄像头', this.paverCamera)
            // 如果之前有视频流,先销毁旧的流
            if (this.paverCamera.videoUrl && this.paverCamera.urlId) {
                await this.disableVideoStream(
                    this.paverCamera.accessToken,
                    this.paverCamera.serialNumber,
                    this.paverCamera.urlId
                );
            }

            // 每次都重新获取新的视频流URL和urlId
            if (this.paverCamera.channelNo && this.paverCamera.serialNumber && this.paverCamera.accessToken) {
                const streamData = await this.getVideoStreamUrl(
                    this.paverCamera.accessToken,
                    this.paverCamera.serialNumber,
                    this.paverCamera.channelNo,
                    this.paverCamera.quality
                );
                this.$set(this.paverCamera, 'videoUrl', streamData.url);
                this.$set(this.paverCamera, 'urlId', streamData.urlId);
                console.log('摊铺机视频URL获取成功');
            }

            this.currentCameraIndex = -1; // 特殊标记
            this.t = this.paverCamera.videoUrl;
            this.img = this.paverCamera.posterUrl;
            this.mixingPlantMin = false;
            this.fronCourtMin = false;

            // 设置云台控制
            this.deviceSerial = this.paverCamera.serialNumber;
            this.channelNo = this.paverCamera.channelNo;
            this.isCanMove = this.paverCamera.isPtz == 1;  // 根据设备实际能力设置

            // 设置云图iframe地址
            let that = this;
            that.$nextTick(function () {
                let oIframeM = document.getElementById("bdIframeMax");
                let deviceWidthM = that.$refs.cloudImgMax ? that.$refs.cloudImgMax.offsetWidth : 0;
                let deviceHeightM = that.$refs.cloudImgMax ? that.$refs.cloudImgMax.offsetHeight : 0;
                if (oIframeM && deviceWidthM > 0) {
                    oIframeM.style.width = Number(deviceWidthM) - 2 + "px";
                    oIframeM.style.height = Number(deviceHeightM) - 2 + "px";
                }
                that.bdTokenUrl1 =
                    `http://59.110.143.238:1088/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=2`;
            });

            this.beginPlayLoading(this.paverCamera.posterUrl)
            this.startEnlargePlay();
            this.initEZPlayer();
        },
        //放大云图
        enlargeCloud() {
            let that = this;
            this.cloudImgFlag = true;
            //设置大云图大小
            that.$nextTick(function () {
                let oIframeM = document.getElementById("bdIframeM");
                let deviceWidthM = that.$refs.cloudImgM ? that.$refs.cloudImgM.offsetWidth : 0;
                let deviceHeightM = that.$refs.cloudImgM ? that.$refs.cloudImgM.offsetHeight : 0;
                if (oIframeM && deviceWidthM > 0) {
                    oIframeM.style.width = Number(deviceWidthM) - 2 + "px";
                    oIframeM.style.height = Number(deviceHeightM) - 2 + "px";
                }
                that.bdTokenUrl2 =
                    // "http://59.110.143.238:1088/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=3";
                    `https://cloudvue-henan.jsti-smart.cn/?workArea=${this.workAreaId}&engineerId=${this.engineerId}&sectionId=${this.sectionId}&isHistory=realTime&materialType=${this.materialType}&source=3&time=${this.getTodayDate()}&authkey=${this.generateTimestampId()}`;
            });
            // 59.110.143.238:8088
        },
        // 用户点击播放按钮 / 放大后起播：启动自动暂停计时，保留封面直到出画面
        startEnlargePlay() {
            this.enlargePlayStartTime = Date.now();

            if (this.enlargePlayTimer) {
                clearTimeout(this.enlargePlayTimer);
                this.enlargePlayTimer = null;
            }
            const maxPlayMs = this.MAX_PLAY_MINUTES * 60 * 1000;
            this.enlargePlayTimer = setTimeout(() => {
                this.pauseEnlargeVideo();
            }, maxPlayMs);

            if (this.ezPlayerInstance) {
                this.ezPlayerInstance.play();
                console.log('EZUIKit 播放器开始播放');
            }

            console.log(`视频开始播放，将在${this.MAX_PLAY_MINUTES}分钟后自动暂停`);
        },
        // 视频播放事件回调
        onEnlargeVideoPlay() {
            console.log('放大弹框视频开始播放');
            this.isEnlargePlaying = true
            this.finishPlayLoading()
            if (!this.enlargePlayTimer) {
                this.enlargePlayStartTime = Date.now();
                const maxPlayMs = this.MAX_PLAY_MINUTES * 60 * 1000;
                this.enlargePlayTimer = setTimeout(() => {
                    this.pauseEnlargeVideo();
                }, maxPlayMs);
            }
        },
        // 暂停放大视频
        async pauseEnlargeVideo() {
            if (!this.ezPlayerInstance) return;

            this.finishPlayLoading()
            // 先调用萤石云截图API获取暂停画面
            await this.capturePauseImage();

            // 停止播放器
            try {
                this.ezPlayerInstance.stop();
            } catch (e) { /* ignore */ }
            this.isEnlargePlaying = false;

            // 清除定时器
            if (this.enlargePlayTimer) {
                clearTimeout(this.enlargePlayTimer);
                this.enlargePlayTimer = null;
            }

            let playedMinutes = 0;
            if (this.enlargePlayStartTime) {
                const playedMs = Date.now() - this.enlargePlayStartTime;
                playedMinutes = Math.floor(playedMs / 60000);
            }

            console.log(`视频已自动暂停，已播放${playedMinutes}分钟`);
        },
        // 重新播放视频（先销毁旧流，再获取新流）
        async resumeEnlargePlay() {
            let currentCamera = null;

            if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                currentCamera = this.mixingPlantCameras[this.currentCameraIndex];
            } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                currentCamera = this.paverCamera;
            }

            if (!currentCamera) return;

            // 保留当前暂停封面，进入 loading
            this.beginPlayLoading(this.pauseImageUrl || currentCamera.posterUrl || '')

            if (currentCamera.videoUrl && currentCamera.urlId) {
                await this.disableVideoStream(
                    currentCamera.accessToken,
                    currentCamera.serialNumber,
                    currentCamera.urlId
                );
            }

            if (currentCamera.channelNo && currentCamera.serialNumber && currentCamera.accessToken) {
                const streamData = await this.getVideoStreamUrl(
                    currentCamera.accessToken,
                    currentCamera.serialNumber,
                    currentCamera.channelNo,
                    currentCamera.quality
                );

                this.t = streamData.url;

                if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                    this.$set(this.mixingPlantCameras[this.currentCameraIndex], 'urlId', streamData.urlId);
                } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                    this.$set(this.paverCamera, 'urlId', streamData.urlId);
                }

                console.log('重新获取视频流成功');
            }

            this.startEnlargePlay();
            this.initEZPlayer();
        },
        // 捕获暂停帧（调用萤石云截图API）
        async capturePauseImage() {
            let accessToken = this.tokenStr
            if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                accessToken = this.mixingPlantCameras[this.currentCameraIndex].accessToken || accessToken
            } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                accessToken = this.paverCamera.accessToken || accessToken
            }

            if (!this.deviceSerial || !accessToken) {
                console.warn('缺少设备信息，无法截图');
                return;
            }

            const params = {
                accessToken,
                deviceSerial: this.deviceSerial,
                channelNo: this.channelNo || '1'
            };

            try {
                const res = await captureImage(params);
                const picUrl = res && res.data && res.data.data ? res.data.data.picUrl : '';

                if (picUrl) {
                    this.pauseImageUrl = picUrl;
                    // 同步回小屏封面
                    if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                        this.$set(this.mixingPlantCameras[this.currentCameraIndex], 'posterUrl', picUrl)
                    } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                        this.$set(this.paverCamera, 'posterUrl', picUrl)
                    }
                    console.log(`暂停截图成功:`, picUrl);
                } else {
                    console.warn('萤石云截图失败，未返回图片URL');
                }
            } catch (error) {
                console.error('调用萤石云截图API失败:', error);
            }
            this.$forceUpdate()
        },
        // 切换播放/暂停状态
        async togglePlayPause() {
            if (this.isEnlargePlaying) {
                // 当前正在播放，执行暂停
                await this.pauseEnlargeVideo();
            } else {
                // 当前已暂停，执行播放
                await this.resumeEnlargePlay();
            }
        },
        // 截图功能（使用 EZUIKit 内置截图或 API 截图）
        async captureScreenShot() {
            try {
                // // 优先使用 EZUIKit 播放器的截图方法
                // if (this.ezPlayerInstance && typeof this.ezPlayerInstance.capturePicture === 'function') {
                //     const result = this.ezPlayerInstance.capturePicture();
                //     console.log('EZUIKit 截图结果:', result);

                //     if (result) {
                //         this.$message.success('截图成功！');
                //         // 如果返回的是图片 URL，可以打开新窗口显示
                //         if (typeof result === 'string') {
                //             window.open(result, '_blank');
                //         }
                //         return;
                //     }
                // }

                // 降级方案：调用 API 截图
                await this.capturePauseImage();
                if (this.pauseImageUrl) {
                    this.$message.success('截图成功！');
                    // 在新窗口打开截图
                    window.open(this.pauseImageUrl, '_blank');
                } else {
                    this.$message.warning('截图失败，请重试');
                }
            } catch (error) {
                console.error('截图失败:', error);
                this.$message.error('截图失败');
            }
        },
        // 全屏切换
        toggleFullscreen() {
            const container = document.getElementById(this.videoContainerId);
            if (!container) return;

            if (!document.fullscreenElement) {
                // 进入全屏
                if (container.requestFullscreen) {
                    container.requestFullscreen();
                } else if (container.webkitRequestFullscreen) {
                    container.webkitRequestFullscreen();
                } else if (container.mozRequestFullScreen) {
                    container.mozRequestFullScreen();
                } else if (container.msRequestFullscreen) {
                    container.msRequestFullscreen();
                }
            } else {
                // 退出全屏
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
        },
        // 销毁当前正在播放的视频流
        destroyCurrentStream() {
            let cameraToDestroy = null;

            // 根据 currentCameraIndex 确定要销毁的摄像头
            if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                cameraToDestroy = this.mixingPlantCameras[this.currentCameraIndex];
            } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                cameraToDestroy = this.paverCamera;
            }

            // 调用销毁接口
            if (cameraToDestroy && cameraToDestroy.accessToken && cameraToDestroy.serialNumber && cameraToDestroy.urlId) {
                this.disableVideoStream(
                    cameraToDestroy.accessToken,
                    cameraToDestroy.serialNumber,
                    cameraToDestroy.urlId
                );

                // 清空urlId,下次打开时重新获取
                if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                    this.$set(this.mixingPlantCameras[this.currentCameraIndex], 'urlId', '');
                } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                    this.$set(this.paverCamera, 'urlId', '');
                }
            }
        },
        // 初始化 EZUIKit 播放器
        initEZPlayer() {
            this.$nextTick(() => {
                // 销毁旧实例
                if (this.ezPlayerInstance) {
                    this.ezPlayerInstance.close();
                    this.ezPlayerInstance = null;
                }

                const container = document.getElementById(this.videoContainerId);
                if (!container || !this.t) {
                    console.warn('播放器容器或视频URL为空，无法初始化');
                    return;
                }

                // 获取当前摄像头的 accessToken
                let currentAccessToken = '';

                if (this.currentCameraIndex >= 0 && this.currentCameraIndex < this.mixingPlantCameras.length) {
                    const camera = this.mixingPlantCameras[this.currentCameraIndex];
                    currentAccessToken = camera.accessToken || this.tokenStr;
                } else if (this.currentCameraIndex === -1 && this.paverCamera) {
                    currentAccessToken = this.paverCamera.accessToken || this.tokenStr;
                } else {
                    currentAccessToken = this.tokenStr;
                }

                if (!currentAccessToken) {
                    console.warn('accessToken 为空，无法初始化播放器');
                    this.$message.warning('视频播放失败：缺少授权信息');
                    return;
                }

                try {
                    // 与 PC 端一致：直接使用接口返回的完整 URL
                    this.ezPlayerInstance = new EZUIKit.EZUIKitPlayer({
                        id: this.videoContainerId,
                        accessToken: currentAccessToken,  // 使用当前设备的 accessToken
                        url: this.t,  // 直接使用接口返回的完整播放地址
                        template: 'simple',  // 简单模式，与 PC 端一致
                        themeData: buildHideGlobalFullscreenTheme(),
                        width: container.offsetWidth || 1266,
                        height: container.offsetHeight || 700,
                        autoplay: true  // 自动播放
                    });

                    this.isEnlargePlaying = false

                    const onReady = () => {
                        this.isEnlargePlaying = true
                        this.finishPlayLoading()
                        console.log('视频开始播放')
                    }

                    this.ezPlayerInstance.on('firstFrameDisplay', onReady)
                    this.ezPlayerInstance.on('play', () => {
                        this.isEnlargePlaying = true
                        // 部分环境无 firstFrameDisplay，稍延后结束 loading
                        if (this.playLoading) {
                            setTimeout(() => {
                                this.finishPlayLoading()
                            }, 400)
                        }
                        console.log('视频开始播放');
                    });

                    this.ezPlayerInstance.on('pause', () => {
                        this.isEnlargePlaying = false;
                        this.finishPlayLoading()
                        console.log('视频已暂停');
                    });

                    this.ezPlayerInstance.on('error', (error) => {
                        console.error('EZUIKit 播放器错误:', error);
                        this.finishPlayLoading()
                    });

                    console.log('EZUIKit 播放器初始化成功');
                } catch (error) {
                    console.error('EZUIKit 播放器初始化失败:', error);
                    this.finishPlayLoading()
                    this.$message.error('视频播放器初始化失败');
                }
            });
        },
        // 销毁 EZUIKit 播放器
        destroyEZPlayer() {
            if (this.ezPlayerInstance) {
                try {
                    // 1. 先停止拉流
                    if (typeof this.ezPlayerInstance.stop === 'function') {
                        this.ezPlayerInstance.stop();
                    }

                    // 2. 销毁播放器实例（ezuikit-js 使用 close 方法）
                    if (typeof this.ezPlayerInstance.close === 'function') {
                        this.ezPlayerInstance.close();
                    }

                    console.log('EZUIKit 播放器已停止并销毁');
                } catch (error) {
                    console.error('销毁 EZUIKit 播放器时出错:', error);
                } finally {
                    // 3. 销毁播放器对象，释放内存
                    this.ezPlayerInstance = null;

                    // 4. 手动清空播放器绑定的容器DOM
                    const container = document.getElementById(this.videoContainerId);
                    if (container) {
                        container.innerHTML = '';
                    }

                    console.log('EZUIKit 播放器已彻底销毁');
                }
            }
        },
        close() {
            // 清理播放定时器
            if (this.enlargePlayTimer) {
                clearTimeout(this.enlargePlayTimer);
                this.enlargePlayTimer = null;
            }
            this.clearPlayLoadingTimer()
            this.playLoading = false
            this.isEnlargePlaying = false;
            this.enlargePlayStartTime = null;
            this.pauseImageUrl = ''

            //关闭时判断打开时是视频还是云图
            if (this.cloudImgFlag) {
                this.cloudImgFlag = false;
            } else {
                // 先销毁 EZUIKit 播放器
                this.destroyEZPlayer();

                // 销毁当前播放的视频流
                this.destroyCurrentStream();

                this.mixingPlantMin = true;
                this.fronCourtMin = true;
                this.currentCameraIndex = -1;
                // 清空放大视频URL和海报图，销毁视频播放器以节省流量
                this.t = '';
                this.img = '';
                this.$store.commit('updataHcCameraKey', '')
            }
        },
    },
    computed: {
        ...mapState([
            "engineerId",
            "engineerSsoId",
            "sectionId",
            "sectionSsoId",
            "workAreaId",
            "introduction",
            "Participation",
            "construction",
            "supervisor",
            "Design",
            "mixplantOpen",
            "fronCourOpen",
            "hcCameraKey",
            "seIds",
            "mixplantId",      // 新增:监听mixplantId
            "mixplantName"     // 新增:监听mixplantName
        ])
    },
    watch: {
        engineerId(curVal, oldVal) {
        },
        sectionId(curVal, oldVal) {
            if (!curVal || curVal === oldVal) return;
            if (oldVal === undefined || oldVal === '' || oldVal === null) return;

            console.log('作业面切换, 重新加载视频', curVal);
            this.allMixingPlantDevices = [];
            this.allPaverDevices = [];

            let mixplantNo = '';
            if (this.mixplantName) {
                const parts = this.mixplantName.split('-');
                mixplantNo = parts.length > 1 ? parts[parts.length - 1] : '';
            }
            this.getVideo(mixplantNo);
        },
        workAreaId(curVal, oldVal) {
            // 不再自动调用getVideo,等待mixplantId变化时再调用
            // this.getVideo()
        },
        // 新增:监听mixplantId变化
        mixplantId(curVal, oldVal) {
            if (curVal && curVal !== oldVal) {
                // mixplantName格式为 "拌合楼名称-编号",提取编号
                if (this.mixplantName) {
                    const parts = this.mixplantName.split('-');
                    const mixplantNo = parts.length > 1 ? parts[parts.length - 1] : '';
                    console.log('拌合楼切换, mixplantNo:', mixplantNo);
                    // 如果缓存为空则调用接口获取所有设备,否则从缓存过滤
                    if (this.allMixingPlantDevices.length === 0) {
                        console.log('首次加载,调用接口获取设备列表');
                        this.getVideo(mixplantNo);
                    } else {
                        console.log('从缓存中过滤设备');
                        this.filterMixingPlantCameras(mixplantNo);
                    }
                }
            }
        },
        mixplantOpen(curVal, oldVal) {
            console.log(curVal)
            console.log(this.mixingPlantMin)
            this.mOpen = curVal
            this.getRealChannels(2)
            if (this.mOpen) {
                // 传递mixplantNo参数
                if (this.mixplantName) {
                    const parts = this.mixplantName.split('-');
                    const mixplantNo = parts.length > 1 ? parts[parts.length - 1] : '';
                    // 如果缓存为空则调用接口,否则从缓存过滤
                    if (this.allMixingPlantDevices.length === 0) {
                        this.getVideo(mixplantNo);
                    } else {
                        this.filterMixingPlantCameras(mixplantNo);
                    }
                } else {
                    if (this.allMixingPlantDevices.length === 0) {
                        this.getVideo();
                    }
                }
            }
        },
        fronCourOpen(curVal, oldVal) {
            this.fOpen = curVal
            console.log(this.workAreaId)
            console.log(this.engineerId)
            this.getRealChannels(1)
            if (this.fOpen) {
                // 如果缓存为空且有mixplantName,则调用接口
                if (this.allMixingPlantDevices.length === 0 && this.mixplantName) {
                    const parts = this.mixplantName.split('-');
                    const mixplantNo = parts.length > 1 ? parts[parts.length - 1] : '';
                    this.getVideo(mixplantNo);
                } else if (this.allMixingPlantDevices.length === 0) {
                    this.getVideo();
                }
            }
        },
        hcCameraKey(curVal) {
            if (curVal) {
                this.openHcCameraEnlarge(curVal)
            }
        },
        $route(to, from) {
            console.log(to.path);
            if (to.path.indexOf("lq") >= 0) {
                this.materialType = "lq"
            } else {
                this.materialType = "sw"
            }
            this.$store.commit("updataMixplantOpen", false);
            this.$store.commit("updataFronCourOpen", false);
            this.$store.commit("updataHcCameraKey", '');
            this.mOpen = false
            this.fOpen = false
        }
    },
};
</script>
<style lang="less" scoped>
/deep/.vjs-control-bar {
    display: none;
}

.fronCourt {
    width: 135px;
    height: 80px;
    position: absolute;
    // bottom: 40px;
    bottom: 20px;
    right: 20px;
    // background-color: #fff;
    z-index: 999;
    background: rgba(0, 0, 0, 1);
    border: 4px solid rgba(45, 252, 251, .5);
    padding: 4px;

    .offline-tip {
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 80px;
        height: 20px;
    }
}

.mixingPlantBox {
    position: absolute;
    left: 20px;
    bottom: 20px;
    background: rgba(9, 23, 71, .5);
    border: 4px solid rgba(45, 252, 251, .5);
    padding: 4px;
    box-sizing: border-box;
    padding-bottom: 0;

    .mixingPlant {
        width: 135px;
        height: 80px;
        // bottom: 30px;
        display: inline-block;
        background: rgba(0, 0, 0, 1);
        z-index: 999;
        position: relative;

        .offline-tip {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 12px;
            text-align: center;
        }
    }
}

// .mixingPlant {

//     // left: 30px;
//     // bottom: 30px;
//     // background:rgba(9,23,71,.5);
//     // border:4px solid rgba(45,252,251,.5);
//     // padding:4px;
//     /deep/.video-wrapper {
//         // padding-bottom:64% !important;
//     }

//     .cloudImgMax {
//         width: 420px;
//         height: 300px;
//         border: 1px solid #000;
//         position: absolute;
//         top: 0;
//         right: 0;
//         box-sizing: border-box;
//         z-index: 9;

//         .btnL {}

//         .btnR {}

//         .btnT {}

//         .btnB {}

//         .mantle {
//             width: 420px;
//             height: 300px;
//             position: absolute;
//             top: 0;
//             right: 0;
//             z-index: 999999;
//         }
//     }
// }

.cloudImg {
    width: 70px;
    height: 50px;
    position: absolute;
    top: 0;
    right: 0;
    border: 1px solid #000;
    box-sizing: border-box;
    z-index: 9;
}

.enlargeVideo {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;

    .close {
        position: absolute;
        width: 40px;
        height: 40px;
        top: 130px;
        right: 200px;
        font-size: 28px;
        text-align: center;
        line-height: 40px;
        border-radius: 50%;
        border: 3px solid #fff;
        color: #fff;
        // transform:rotate(45deg);
        // -webkit-transform:rotate(45deg);
        // -moz-transform:rotate(45deg);
    }

    .videos {
        width: 1266px;
        height: 700px;
        position: relative;
        left: 50%;
        top: 50%;
        margin-left: -622px;
        margin-top: -405px;
        background-color: #000;
        border: 2px solid #000;

        .cloudImgMax1 {
            width: 200px;
            height: 200px;
            // border: 1px solid #000;
            position: absolute;
            top: 0;
            right: 0;
            box-sizing: border-box;
            z-index: 9;

            .btnL {
                position: absolute;
                top: 30%;
                font-size: 100px;
                border-radius: 30px;
                color: #44F8FF;
            }

            .btnR {
                position: absolute;
                font-size: 100px;
                top: 30%;
                right: 0;
                border-radius: 30px;
                color: #44F8FF;
            }

            .btnT {
                position: absolute;
                font-size: 100px;
                left: 25%;
                color: #44F8FF;
            }

            .btnB {
                position: absolute;
                font-size: 100px;
                left: 25%;
                bottom: -35px;
                color: #44F8FF;
            }
        }

        .cloudImgMax {
            width: 420px;
            height: 300px;
            border: 1px solid #000;
            position: absolute;
            top: 0;
            right: 0;
            box-sizing: border-box;
            z-index: 9;

            .mantle {
                width: 420px;
                height: 300px;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 999999;
            }
        }
    }

    .cloudImgM {
        width: 1266px;
        height: 810px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -622px;
        margin-top: -405px;
        background-color: #fff;
        border: 2px solid #000;
    }
}

.gifBtn {
    position: fixed;
    bottom: 130px;
    // bottom: 50px;
    right: 25px;
    width: 140px;
    height: 140px;
}

.cloudImgMBox {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .6);
    z-index: 1002;
}

.cloudImgM {
    width: 97vw;
    height: 92vh;
    position: absolute;
    z-index: 1002;
    left: 1vw;
    top: 5vh;
    background-color: #fff;
    border: 2px solid #000;
}

.closeCloud {
    position: absolute;
    right: -25px;
    top: -30px;
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background-color: #fff;
    border: 1px splid #000;
    text-align: center;
    line-height: 50px;
    font-weight: 900;
    font-size: 25px;
}

// 小屏占位符样式
.camera-placeholder {
    width: 100%;
    height: 100%;
    position: relative;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
}

.camera-placeholder img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.camera-placeholder .play-hint {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.camera-placeholder .play-hint-icon {
    font-size: 30px;
    color: #fff;
}

.video-stage {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #000;
}

// EZUIKit 播放器容器样式
.ez-video-container {
    width: 100%;
    height: 100%;
    position: relative;
}

// 暂停封面（放在播放器容器外）
.pause-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 10;
    background-color: #000;
    pointer-events: none;
}

.play-loading {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 25;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
    color: #fff;
    pointer-events: none;

    .play-loading-icon {
        font-size: 40px;
        color: #fff;
    }

    .play-loading-text {
        margin-top: 10px;
        font-size: 14px;
        letter-spacing: 1px;
    }
}

// 暂停时的播放按钮遮罩层
.play-button-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 20;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.3);
    transition: background-color 0.3s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .play-icon {
        font-size: 80px;
        color: #fff;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
        transition: transform 0.3s ease;
        margin-bottom: 15px;
    }

    .play-text {
        font-size: 18px;
        color: #fff;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
        letter-spacing: 2px;
    }

    &:hover .play-icon {
        transform: scale(1.1);
    }
}

// 覆盖 EZUIKit 默认样式（如需要）
/deep/.ezui-player-wrapper {
    width: 100% !important;
    height: 100% !important;
}

// 自定义控制按钮栏
.video-control-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    z-index: 30;

    .control-left,
    .control-right {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .control-btn {
        font-size: 24px;
        color: #fff;
        cursor: pointer;
        padding: 5px;
        transition: all 0.3s ease;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

        &:hover {
            color: #409EFF;
            transform: scale(1.2);
        }

        &:active {
            transform: scale(0.95);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/video.vue